// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum BankAccountStatus {
  Active = "ACTIVE",
  PairingOnly = "PAIRING_ONLY",
  Disabled = "DISABLED",
}
export default BankAccountStatus;
